export default __webpack_public_path__ + "static/media/background-sleep.fe6aaee4.jpg";